import React, { type ReactNode } from 'react';

import classnames from 'classnames';

import styles from './ButtonBase.module.scss';

export type ButtonContentProps = {
    children: ReactNode;
    className?: string;
};

const ButtonContent = ({ children, className }: ButtonContentProps) => (
    <span className={classnames(styles.content, className)}>{children}</span>
);

export { ButtonContent };
